//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { DEFAULT_CHART_OPTIONS } from '@facebook/constants/facebookChartConstants';
import { SocialNetwork } from '@models/SocialNetwork';
import { getReachTooltipContentCaveat } from '@utils/social-text-utils/socialTextUtils';

export enum FacebookSummaryChartOptions {
  CHANGE_IN_FANS = 'changeInFans',
  REACH = 'reach',
  VISITS = 'visits',
}

export const FACEBOOK_SUMMARY_CHART_LABELS = {
  [FacebookSummaryChartOptions.CHANGE_IN_FANS]: 'Change in Fans',
  [FacebookSummaryChartOptions.REACH]: 'Page Reach',
  [FacebookSummaryChartOptions.VISITS]: 'Link Clicks',
};

export const FACEBOOK_SUMMARY_CHART_OPTIONS = {
  [FacebookSummaryChartOptions.CHANGE_IN_FANS]: DEFAULT_CHART_OPTIONS,
  [FacebookSummaryChartOptions.REACH]: DEFAULT_CHART_OPTIONS,
  [FacebookSummaryChartOptions.VISITS]: DEFAULT_CHART_OPTIONS,
};

export const FacebookSummaryStatBubbleTitle = {
  ChangeInFans: 'Change in Fans',
  PageReach: 'Page Reach',
  LinkClicks: 'Link Clicks',
};

export const FacebookSummaryStatBubbleTooltips = {
  ChangeInFans:
    'Net change in users who have "liked" your page over the last 7 days.',
  PageReach: `Unique users who have viewed any of your Facebook posts over the last 7 days. ${getReachTooltipContentCaveat(
    SocialNetwork.Facebook,
  )}`,
  LinkClicks:
    'Total clicks on any links in your Facebook posts over the last 7 days.',
};
